import { useState, Fragment } from "react";
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import {
  ArrowLeftStartOnRectangleIcon,
  ChevronDownIcon,
} from "@heroicons/react/20/solid";
import { useLocation, useMatch, useNavigate } from "react-router";
import * as React from "react";
import { useAuthStore } from "../../../store/useAuthStore";
import Avatar from "../../../shared/Avatar";
import LogoutModal from "./LogoutModal";
import { HStack, VStack } from "../../../shared/utils";
import useIsMobile from "../../../utils/detectDevice";
import { Icon } from "@iconify/react";
import ChangePasswordModal from "./ChangePasswordModal";
import { useGetPlatformInfo } from "../../../queries/auth";
import { trackEvent } from "../../../utils/AmpAnalytics";

export function FlyoutProfile() {
  const [dialogLogout, setDialogLogout] = useState(false);
  const [show, setShown] = useState(false);
  const [dialogUserProfile, setDialogUserProfile] = useState(false);
  const { isMobile } = useIsMobile(1025);

    const { accessToken } = useAuthStore();
    const { data: userPlatformData } = useGetPlatformInfo(
      accessToken || "",
      accessToken !== undefined && accessToken !== ""
    );

  const navigate = useNavigate();
const profileImage = (userPlatformData && userPlatformData[0].profilePicUrl) || undefined;
  const contextRef = React.useRef<HTMLDivElement>(null);
  const contextRef2 = React.useRef<HTMLDivElement>(null);
  const { email, name } = useAuthStore();
  const routes = [
    {
      name: "User Profile",
      onClick: () => {
        trackEvent("Navigating to profile");
        setDialogUserProfile(true);
      },
      type: "iconify",
      icon: "flowbite:profile-card-solid",
    },
    {
      name: "Log Out",
      onClick: () => {
        setDialogLogout(true);
        setShown(false);
      },
      icon: ArrowLeftStartOnRectangleIcon,
    },
  ];

  React.useEffect(() => {
    if (dialogUserProfile === true) {
      setDialogUserProfile(false);
      navigate("/landing/userProfile");
    }
  }, [dialogUserProfile]);

  const profileMatch = useMatch(`/${"/user/profile".split("/")[1]}/*`);
  const { pathname } = useLocation();

  return (
    <div>
      {false ? (
        <div className="items-center px-6 py-2">
          <p className="text-sm animate-pulse font-medium">Switching...</p>
        </div>
      ) : (
        <Popover className="relative">
          {dialogLogout && (
            <LogoutModal
              isOpen={dialogLogout}
              onClose={() => {
                setDialogLogout(false);
              }}
            />
          )}
          <Popover className="relative">
            <div>
              <PopoverButton
                onClick={() => setShown(!show)}
                onMouseEnter={() => {
                  setShown(true);
                }}
                onMouseLeave={() => {
                  setShown(false);
                }}
                className={`-ml-1.5 flex gap-2 cursor-pointer items-center p-1 focus:outline-none ${
                  "/profile" !== pathname
                    ? "bg-white text-secondary"
                    : "bg-secondary text-white"
                } `}
              >
                <Avatar name={name || ""} profileImage={profileImage} />
                {/* {!isMobile && <><p className="text-sm text-gray-700">{name}</p>
                <span className="hidden lg:flex lg:items-center">
                  <ChevronDownIcon
                    className="ml-2 h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </span>
                </>} */}
              </PopoverButton>
            </div>
            <Transition
              show={show}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <PopoverPanel
                onMouseEnter={() => {
                  setShown(true);
                }}
                onMouseLeave={() => {
                  setShown(false);
                }}
                ref={contextRef}
                className="absolute z-10 mt-5 flex w-screen max-w-max  right-0 "
              >
                <div className="w-screen max-w-xs flex-auto overflow-hidden rounded-lg bg-white text-sm leading-6 shadow-lg">
                  <div className="divide-x divide-gray-900/5 bg-gray-50">
                    <div className="group relative flex gap-x-2 rounded-lg p-4 hover:bg-gray-50">
                      <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                        <Avatar name={name || ""} profileImage={profileImage} />
                      </div>
                      <VStack className="w-full">
                        <HStack className="justify-between items-center w-full">
                          <a className="font-semibold text-gray-900 flex-1">
                            {name}

                            <span className="absolute inset-0" />
                          </a>

                          <a className="ml-1 text-sm text-gray-500 text-ellipsis overflow-clip"></a>
                        </HStack>

                        <p className="text-gray-600 whitespace-nowrap">
                          {email}
                        </p>
                        <p className="text-sm text-gray-500 text-ellipsis overflow-clip"></p>
                      </VStack>
                    </div>
                  </div>

                  <div className="p-2  cursor-pointer">
                    {routes.map((item) => (
                      <div
                        key={item.name}
                        onClick={() => {
                          item.onClick();
                        }}
                        className="group relative flex gap-x-4 rounded-lg p-2 hover:bg-gray-50 items-center"
                      >
                        <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                          {item.type !== "iconify" && (
                            <item.icon
                              className={`h-6 w-6 text-gray-600 group-hover:text-primary ${
                                profileMatch && item.name === "Profile"
                                  ? "text-primary"
                                  : ""
                              }`}
                              aria-hidden="true"
                            />
                          )}
                          {item.type === "iconify" &&
                            typeof item.icon === "string" && (
                              <Icon
                                icon={item.icon || ""}
                                className={`h-6 w-6 text-gray-600 group-hover:text-primary ${
                                  profileMatch && item.name === "Profile"
                                    ? "fill-primary"
                                    : ""
                                }`}
                              />
                            )}
                        </div>
                        <div>
                          <a
                            className={`font-semibold text-gray-900 group-hover:text-primary ${
                              profileMatch && item.name === "Profile"
                                ? "text-primary"
                                : ""
                            }`}
                          >
                            {item.name}
                            <span className="absolute inset-0" />
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </PopoverPanel>
            </Transition>
          </Popover>
        </Popover>
      )}
    </div>
  );
}
